import { useTranslation as usei18nTranslation } from "react-i18next";

export const useTranslation = (path?: string) => {
  const { t } = path
    ? usei18nTranslation("translation", { keyPrefix: path })
    : usei18nTranslation();

  return { t };
};
